import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription,lastValueFrom, take } from 'rxjs';
import { getAllState } from '../../../../configurator-app/conf-store/reducer';
import { Store, select } from '@ngrx/store';
import * as actions from '../../../conf-store/action/index';
import conf_3d_model from '../../../Conf-Shared/StaticData/HCV/model-name.json';
import * as $ from 'jquery';
import { environment } from '../../../../../environments/environment.prod';
import { ConfLobControlService } from '../../Services/conf-lob-service/conf-lob-control.service';

declare let ONE3D: any;


@Component({
  selector: 'app-conf-carousel',
  templateUrl: './conf-carousel.component.html',
  styleUrls: ['./conf-carousel.component.scss']
})
export class ConfCarouselComponent implements OnInit, OnDestroy {
  confAWSUrlStr: any = environment.confAWSurl;
  confAWS3DUrlStr: any = environment.confAWS3Durl
  clickModal: any = 0
  conf3dLoaded: boolean = false;
  showModalButton: boolean = false
  script3D: any;
  doorClick = 0;
  lightClick = 0;

  isExterior: any = "exterior_selected";
  isInterior: any = "interior_unselected"
  showModalType: any = ""
  show3dModel: boolean = true;
  colorClick = 0;
  isColorVisible: boolean = false;
  colorCodes: any;
  selectedColorCodeIndex: any;
  isDoorVisible: boolean = true;
  isLightVisible: boolean = true;
  _3dPostSubscription: any = new Subscription;

  @Input() vc_number: any;
  @Output() showModel = new EventEmitter();
  @Input() lobName: any;
  @Input() pl: any
 

  constructor(private _dataLobService: ConfLobControlService,private store: Store,) { }

  show_model_view(event: any) {
    this.showModel.emit(false);
    this.showModalType = event
    this.show3dModel = !this.show3dModel;
    this.clickModal++
    if (this.lightClick % 2 == 1) {
      $('.conf-light-img').removeClass('conf-light-active')
      $('.conf-light-img img').attr('src', this.confAWSUrlStr + '/common/light_unselected.svg')
      this.lightClick++
      ONE3D.toggleLights();
    }
  }

  async ngOnInit():Promise<void> {
    let _3dData: any = {};
     if(this.lobName == 'magic'){
      _3dData['lob_name'] = 'tata_magic';
     }
     else{
      _3dData['lob_name'] = this.lobName;
     }
     
    _3dData['output_type'] = 'all',
    _3dData['vc_no'] = this.vc_number
  
    _3dData['pl'] = this.pl;

    this._3dPostSubscription = this._dataLobService.getLobFilterData('osp_configurator_3d_image_filter', _3dData).subscribe((res: any) => {
      if (res['RESPONSE']['STATUS_CODE'] == 200) {
        if (res['RESPONSE']['DATA'].length > 0) {

          let data = res['RESPONSE']['DATA'][0];
          var model_ID = data.model_name;
          var variant_ID = data.variant_name;
          this.colorCodes = JSON.parse(data.color_name.replace(/'/g, '"'));
 
        
          if (data.color_flag === 'FALSE') this.isColorVisible = false;
          else {
            this.isColorVisible = true;
            this.selectedColorCodeIndex = 0
          }         

          if (data.door_flag === 'FALSE') this.isDoorVisible = false;
          else this.isDoorVisible = true;

          if (data.light_flag === 'FALSE') this.isLightVisible = false;
          else this.isLightVisible = true;

          let datafolder: any = ""
          this.showModalButton = true

          this.script3D = document.createElement('script');
          this.script3D.src = ""; //initialsing empty

          this.script3D.type = 'text/javascript';
          this.script3D.id = 'carF';
          this.script3D.async = true;
          this.script3D.src = this.confAWS3DUrlStr + data.src;

          document.body.appendChild(this.script3D);

          this.script3D.onload = async () => {
            ONE3D.init("one3d", this.confAWS3DUrlStr + "/3D/" + this.lobName + "/", model_ID, variant_ID, {
              callback:()=> this.OnLoadingComplete(),
              onProgress: this.getLoaderProgress,
              showDefaultLoader: false,
            });
          };

        } else {
          this.showModalButton = false
        }
      }
    })

  }

  getLoaderProgress(progress: number) {

    if (progress !== 100)
      $('#conf-progress-percentage').html(`<b>${progress}%</b>`);
    else {
      $('#conf-progress-percentage').remove();
      $('.conf-3d-progress').remove();
      $('#conf-progress-img').remove();
    }
  }
 
  OnLoadingComplete() {
    //Assign hotspot event

    ONE3D.setBackgroundAlpha(0);

    var options = {
      onEventClicked: (evtClicked: any) => {
        if (evtClicked.message == "Interior View Start") {
          // console.log("IF")
          $('.conf-ext-img').removeClass('conf-ext-active')
          $('.conf-int-img').addClass('conf-int-active')
          $('.conf-int-img img').attr('src', this.confAWSUrlStr + '/common/interior_selected.svg')
          $('.conf-ext-img img').attr('src', this.confAWSUrlStr + '/common/exterior_unselected.svg')
        }

        else if (evtClicked.message == "Exterior View Start") {
          $('.conf-ext-img').addClass('conf-ext-active')
          $('.conf-int-img').removeClass('conf-int-active')
          $('.conf-int-img img').attr('src', this.confAWSUrlStr + '/common/interior_unselected.svg')
          $('.conf-ext-img img').attr('src', this.confAWSUrlStr + '/common/exterior_selected.svg')
        }
      },
      onEventComplete: (evtComplete: any) => {
        // console.log(evtComplete)
      }
    }
    ONE3D.registerClickAction(options);
    ONE3D.changeColor(this.colorCodes[0])
    this.conf3dLoaded = true

    window.addEventListener('resize', function () {
      ONE3D.resizeWindow()
    });

    setTimeout(() => {
      ONE3D.resizeWindow()
    }, 100)
    // console.log("Model Loading Complete.");
    $('#conf-progress-percentage').remove();
    $('.conf-3d-progress').remove();
    $('#conf-progress-img').remove();
  }

  showExtInt(type: any) {
    if (type == 'exterior') {
      $('.conf-ext-img').addClass('conf-ext-active')
      $('.conf-int-img').removeClass('conf-int-active')
      $('.conf-int-img img').attr('src', this.confAWSUrlStr + '/common/interior_unselected.svg')
      $('.conf-ext-img img').attr('src', this.confAWSUrlStr + '/common/exterior_selected.svg')
      ONE3D.exteriorView()
    } else if (type == 'interior') {
      $('.conf-ext-img').removeClass('conf-ext-active')
      $('.conf-int-img').addClass('conf-int-active')
      $('.conf-int-img img').attr('src', this.confAWSUrlStr + '/common/interior_selected.svg')
      $('.conf-ext-img img').attr('src', this.confAWSUrlStr + '/common/exterior_unselected.svg')
      ONE3D.interiorView()
    }
    else if (type == 'door') {
      if (this.doorClick % 2 == 1) {
        $('.conf-door-img').removeClass('conf-door-active')
        $('.conf-door-img img').attr('src', this.confAWSUrlStr + '/common/door_unselected.svg')
      } else {
        $('.conf-door-img').addClass('conf-door-active')
        $('.conf-door-img img').attr('src', this.confAWSUrlStr + '/common/door_selected.svg')
      };

      this.doorClick++
      ONE3D.toggleDoors()
    }
    else if (type == 'light') {
      if (this.lightClick % 2 == 1) {
        $('.conf-light-img').removeClass('conf-light-active')
        $('.conf-light-img img').attr('src', this.confAWSUrlStr + '/common/light_unselected.svg')
      } else {
        $('.conf-light-img').addClass('conf-light-active')
        $('.conf-light-img img').attr('src', this.confAWSUrlStr + '/common/light_selected.svg')
      };

      this.lightClick++
      ONE3D.toggleLights();
    } else if (type == 'color') {
      if (this.colorCodes.length > 0) {
        if (this.colorCodes.length - 1 > this.selectedColorCodeIndex) {
          this.selectedColorCodeIndex += 1;
        } else {
          this.selectedColorCodeIndex = 0;
        }
        $('.conf-color-img').removeClass('conf-color-active')
        $('.conf-color-img img').attr('src', this.confAWSUrlStr + '/common/color_unselected.svg')
        ONE3D.changeColor(this.colorCodes[this.selectedColorCodeIndex]);
      }
      this.colorClick++
    }
  }

  ngOnChanges() {
    /*******************************LOAD 3D MODAL ***************************/

    this.OnLoadingComplete

    /******************************LOAD 3D MODAL *****************************/
  }

  ngOnDestroy() {
    //Check if element present in script
    if (document.getElementById("carF")) {
      document.body.removeChild(this.script3D);
    }

    if (this.lightClick % 2 == 1) {
      $('.conf-light-img').removeClass('conf-light-active')
      $('.conf-light-img img').attr('src', this.confAWSUrlStr + '/common/light_unselected.svg')
      this.lightClick++
      ONE3D.toggleLights();
    }

    if (this._3dPostSubscription) {
      this._3dPostSubscription.unsubscribe();
    }

  }
}
